const envs: Record<string, string> =
  '__ENV__' in window
    ? (window as Window & { __ENV__: Record<string, string> }).__ENV__
    : {}
const isProd = envs.UVO_FIREBASE_CONFIG === 'production'

export const CTV_REGIONS_IDS = {
  pakistan: 167,
  arabworld: isProd ? 255 : 292,
  africa: isProd ? 252 : 268,
  nigeria: isProd ? 252 : 268,
  kenya: isProd ? 252 : 268,
  ghana: isProd ? 252 : 268,
  india: 101,
  latinamerica: isProd ? 257 : 295,
  ukraine: 230,
}

export const CTV_REGION_CATEGORY_IDS: Record<string, number> = {
  nigeria: isProd ? 1049 : 1115,
  ghana: isProd ? 1052 : 1001,
  kenya: isProd ? 1147 : 1193,
}

export const CTV_REGIONS_NAMES = {
  pakistan: 'Pakistan',
  arabworld: 'Arab World',
  africa: 'Africa',
  nigeria: 'Nigeria',
  kenya: 'Kenya',
  ghana: 'Ghana',
  india: 'India',
  latinamerica: 'Latin America',
  ukraine: 'Ukraine',
}

export const CTV_REGIONS = {
  africa: 'afr',
  nigeria: 'afr',
  kenya: 'afr',
  ghana: 'afr',
  arabworld: 'arb',
  india: 'ind',
  latinamerica: 'lam',
  ukraine: 'ukr',
  pakistan: 'pak',
}

export const CTV_ALIAS_IDS = {
  pak: 167,
  arb: isProd ? 255 : 292,
  afr: isProd ? 252 : 268,
  ind: 101,
  lam: isProd ? 257 : 295,
  ukr: 230,
}
